import { FormattedMessage } from 'react-intl';
import { useGetCurrentTenantQuery } from 'store/api/tenants.ts';
import { cn } from 'utils/cn';

type EnvTone = 'success' | 'warning';

const ENVS: Record<string, { tone: EnvTone; short: string }> = {
    dev: { tone: 'success', short: 'DEV' },
    development: { tone: 'success', short: 'DEV' },
    demo: { tone: 'warning', short: 'DEMO' },
    test: { tone: 'warning', short: 'TEST' },
};

const TONE_CLASS: Record<EnvTone, string> = {
    success: 'bg-success-lighter text-fg-success',
    warning: 'bg-warning-lighter text-fg-warning',
};

/**
 * The environment the portal runs in and the current tenant, for the ribbon and the new design's chip; null
 * in production and wherever `VITE_ENV` is unset (CI).
 */
export function useEnvIndicator() {
    const { data: tenant } = useGetCurrentTenantQuery();
    const env = import.meta.env.VITE_ENV ?? '';
    const match = ENVS[env.toLowerCase()];

    return match
        ? {
              ...match,
              environment: env.toLocaleUpperCase(),
              tenant: tenant?.name || 'Loading…',
              /** Undefined until the tenant has been read, and for good when that read failed. */
              tenantName: tenant?.name,
          }
        : null;
}

const EnvIndicatorBar = () => {
    const indicator = useEnvIndicator();

    return indicator ? (
        <div className={cn('flex h-9.5 w-full items-center justify-center', TONE_CLASS[indicator.tone])}>
            <FormattedMessage
                id="portal.environment-indicator"
                values={{ environment: indicator.environment, tenant: indicator.tenant }}
            />
        </div>
    ) : null;
};

export default EnvIndicatorBar;
